window.addEventListener("DOMContentLoaded", () => {
  const triggerElements = document.querySelectorAll(".video-iframe-trigger");
  const iframeWrapper = document.querySelector(
    ".video-section-general__iframe-wrapper"
  );
  const iframe = iframeWrapper.querySelector("iframe");

  triggerElements.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      iframeWrapper.classList.add("iframe-visible");
      iframe.setAttribute(
        "src",
        `https://www.youtube-nocookie.com/embed/${iframeWrapper.dataset.videoid}?autoplay=1`
      );
    });
  });

  iframeWrapper.addEventListener("click", () => {
    iframeWrapper.classList.remove("iframe-visible");
    iframe.setAttribute("src", "");
  });
});
